import { render, staticRenderFns } from "./resetpwd.vue?vue&type=template&id=023aa057&scoped=true&"
import script from "./resetpwd.vue?vue&type=script&lang=js&"
export * from "./resetpwd.vue?vue&type=script&lang=js&"
import style0 from "./resetpwd.vue?vue&type=style&index=0&id=023aa057&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023aa057",
  null
  
)

export default component.exports